<script setup lang="ts">
import { useSEO } from "~/composables/useSeo";
import { useI18n } from "~/composables/useI18n";
import { useResumeStore } from "~/stores/useResumeStore";
import SkillsPageView from "~/components/pages/Skills/SkillsPageView/SkillsPageView.vue";

const t = useI18n();
const store = useResumeStore();
await store.loadResumeData();

useSEO({
  title: `${store.personalInformation?.name} - ${t("skillsPage.pageTitle")}`,
  description: t("skillsPage.pageDescription"),
});
</script>

<template>
  <SkillsPageView />
</template>
